// const HOST = "/api";
// http://192.168.9.13:8080
// export const HOST = "https://api.lky7bet.com"; //生产
export const HOST = "https://api.lky7game.com"; //测试
// export const HOST = "http://192.168.0.109:8080"; //伟漂本地
// export const HOST = "http://192.168.0.177:8080"; //思凡本地
export const PATH = "/app-api";

// clientId
export const clientId = '425a8310cd442757ae699df5d894f052';